// extracted by mini-css-extract-plugin
module.exports = {"header":"Nav_header__3MZCy","icon":"Nav_icon__3Eg5b","logo":"Nav_logo__3zWeS","navSpacer":"Nav_navSpacer__3IziQ"};